import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingSupport from './components/FloatingSupport';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Portfolio from './pages/Portfolio';
import Careers from './pages/Careers';
import Team from './pages/Team';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import JoinUs from './pages/JoinUs';
import Offers from './pages/Offers';
import Legal from './pages/Legal';
import Training from './pages/Training';
import TrainingDetail from './pages/TrainingDetail';
// Chatbot removed
import { ThemeProvider } from './context/ThemeContext';
import AdminLogin from './admin/Login';
import AdminPanel from './admin/AdminPanel';

function App() {
  return (
    <ThemeProvider>
  <Router>
          <div className="min-h-screen bg-slate-50 dark:bg-[#0f172a] transition-colors duration-300">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              {/* Chatbot route removed */}
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:serviceId" element={<ServiceDetail />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/join-us" element={<JoinUs />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/trainings" element={<Training />} />
              <Route path="/trainings/:courseId" element={<TrainingDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/privacy-policy" element={<Legal />} />
              <Route path="/terms-of-service" element={<Legal />} />
              <Route path="/cookie-policy" element={<Legal />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <FloatingSupport />
            <Toaster position="top-center" />
          </div>
        </Router>
    </ThemeProvider>
  );
}

export default App;
